import '../../css/product-page-configurations.scss';
import $ from '@modules/jquery-import';
import 'underscore';
import {Backbone, ProductConfiguratorApp} from '@modules/lazy-imports';
import {CommerceItemLists} from '@upi/data-layer-constants';

window.$ = window.$ || $;

Backbone()
    .then( ProductConfiguratorApp )
    .then( App => {
        const contentEl = document.getElementById( 'body-content' );
        if ( contentEl ) {
            contentEl.classList.remove( 'degraded' );
        }

        App.default.initialize( {itemList: CommerceItemLists.PRODUCT_DETAILS} );
    } );
